import { CategoryQueue } from '../../components/chatWidget/types'

export const targetedBreadCrumbs: Record<string, CategoryQueue> = {
  'computer & tablet accessories': 'home_appliances',
  'food processors, mixers & blenders': 'home_appliances',
  ironing: 'home_appliances',
  kettles: 'home_appliances',
  printing: 'home_appliances',
  'vacuum cleaners': 'home_appliances',
  'heaters, fans & dehumidifiers': 'home_appliances',
  'microwaves & cooking appliances': 'home_appliances',
  toasters: 'home_appliances',
  'coffee machines': 'home_appliances',
  'hair dryers': 'home_appliances',
  'hair straighteners': 'home_appliances',
  'hair stylers': 'home_appliances',
  'hair curlers': 'home_appliances',
  headphones: 'tv_audio',
  'hi-fi, audio & speakers': 'tv_audio',
  televisions: 'tv_audio',
  'dvd, blu-ray, home cinema & soundbars': 'tv_audio',
  'fridges & freezers': 'home_appliances',
  'washing machines & tumble dryers': 'home_appliances',
  dishwashers: 'home_appliances',
  cooking: 'home_appliances',
  bedroom: 'home',
  bedding: 'home',
  'cooking & baking': 'home',
  cutlery: 'home',
  drinkware: 'home',
  'food preparation': 'home',
  tableware: 'home',
  'ceiling & lamp shades': 'home',
  'ceiling lighting': 'home',
  'desk & table lamps': 'home',
  'floor lamps': 'home',
  'garden & outdoor lighting': 'home',
  'light bulbs': 'home',
  'line, fairy & novelty lights': 'home',
  'bathroom lighting': 'home',
  'sad & wake up lighting': 'home',
  'kitchen lighting': 'home',
  'christmas lights': 'home',
  'decorative accessories': 'home',
  'novelty & gadget gifts': 'christmas_gifts',
  'wall lighting': 'home',
  'sofas & armchairs': 'home',
  'advent calendars': 'christmas_gifts',
  'baubles & tree decorations': 'christmas_gifts',
  'christmas candles & candle holders': 'christmas_gifts',
  'christmas cards': 'christmas_gifts',
  'christmas cottage theme': 'christmas_gifts',
  'christmas crackers': 'christmas_gifts',
  'christmas gift wrap, bags & ribbons': 'christmas_gifts',
  'christmas room decorations': 'christmas_gifts',
  'christmas stockings': 'christmas_gifts',
  'christmas tableware': 'christmas_gifts',
  'christmas tree skirts': 'christmas_gifts',
  'christmas trees': 'christmas_gifts',
  'christmas wreaths & garlands': 'christmas_gifts',
  'polar planet theme': 'christmas_gifts',
  'rainbow time capsule theme': 'christmas_gifts',
  'royal fairytale theme': 'christmas_gifts',
  'stocking fillers': 'christmas_gifts',
  'winter fairytale theme': 'christmas_gifts',
  'easter decorations': 'christmas_gifts',
  'easter eggs': 'christmas_gifts',
  'easter sweets and chocolate': 'christmas_gifts',
  "father's day": 'christmas_gifts',
  'foodie gifts': 'christmas_gifts',
  'gift food & alcohol': 'christmas_gifts',
  'gifts for christmas lovers': 'christmas_gifts',
  halloween: 'christmas_gifts',
  "mother's day": 'christmas_gifts',
  "valentine's day": 'christmas_gifts',
  'gift wrap, cards & party shop': 'christmas_gifts',
  'living room': 'home',
  'dining room': 'home',
  'home office': 'home',
  garden: 'home',
  'curtain poles, tracks & accessories': 'home',
  curtains: 'home',
  blinds: 'home',
  'bathroom accessories': 'home',
  'bath & shower mats': 'home',
  towels: 'home',
  bathroom: 'home',
  "children's": 'home',
  "basques & bodysuits": "home",
  "bras": "home",
  "camisoles & slips": "home",
  "lingerie accessories": "home",
  "shapewear": "home",
  "sports bras": "home",
  "women's knickers & briefs": "home",
  "women's thermal underwear": "home",
  "bath & shower": "home",
  "body care": "home",
  "hair care": "home",
  "hair styling": "home",
  "hair treatments": "home",
  "hand & foot care": "home",
  "hand & nail sets": "home",
  "makeup": "home",
  "makeup accessories": "home",
  "men's aftershave": "home",
  "men's grooming & skincare": "home",
  "nail polish & care": "home",
  "lip care": "home",
  "view all skin care": "home",
  "sun cream & after sun": "home",
  "supplements": "home",
  "unisex fragrance": "home",
  "wellness": "home",
  "women's fragrance": "home",
  "backpacks": "home",
  "books": "home",
  "camping & camping accessories": "home",
  "craft accessories": "home",
  "equipment by sport": "home",
  "craft books": "home",
  "craft crochet & sewing kits": "home",
  "dress fabrics & fat quarters": "home",
  "haberdashery accessories": "home",
  "knitting & crochet patterns": "home",
  "knitting needles & crochet hooks": "home",
  "ribbons & trimming": "home",
  "scissors & cutting tools": "home",
  "sewing machines": "home",
  "sewing patterns": "home",
  "threads": "home",
  "wool & yarn": "home",
  "zips & fastenings": "home",
  "holdalls": "home",
  "suitcases": "home",
  "travel & luggage accessories": "home",
  "soundbars": "tv_audio",
  "gaming accessories": "home_appliances",
  "speakers": "tv_audio",
  "printers": "home_appliances",
  "view all tablets": "home_appliances",
  "view all laptops & macbooks": "home_appliances",
  "view all mobile phones": "home_appliances",
  "batteries & chargers": "home_appliances",
  "camera lenses": "home_appliances",
  "cameras": "home_appliances",
  "fans": "home_appliances",
  "microwave ovens": "home_appliances",
  "mini ovens slow cookers & steamers": "home_appliances",
  "mobile phone cases": "home_appliances",
  "smart home monitoring": "home_appliances",
  "smart watch accessories": "home_appliances",
  "view all smart watches": "home_appliances",
  "tv wall mount accessories": "home_appliances",
  "floorcare": "home_appliances",
  "bbq covers & cooking accessories": "home",
  "bbqs": "home",
  "conservatory furniture": "home",
  "firepits": "home",
  "garden furniture sets": "home",
  "garden seating": "home",
  "garden tables": "home",
  "view all baby toys": "home",
  "view all toys": "home",
  "sensory toys": "home",
  "baby gyms & playmats": "home",
  "character shop": "home",
  "baby bedding": "home",
  "cots & cotbeds": "home",
  "cot & cotbed mattresses": "home",
  "moses baskets & cribs": "home",
  "moses basket & crib mattresses": "home",
  "sleeping accessories": "home",
  "nursery furniture ranges & sets": "home",
  "children's chairs & tables": "home",
  "dressers & drawers": "home",
  "changing units": "home",
  "nursery storage": "home",
  "nursery wardrobes": "home",
  "healthcare": "home",
  "baby bathing": "home",
  "baby changing": "home",
  "baby toiletries": "home",
  "view all weaning": "home",
  "feeding essentials": "home",
  "bottles & accessories": "home",
  "breast feeding": "home",
  "car seats": "home",
  "pushchairs & prams": "home",
  "baby travel systems": "home",
  "pushchair accessories": "home",
  "baby carriers": "home",
  "travel cots": "home",
  "baby travel essentials": "home",
  "carrycots": "home",
  "toddler backpacks": "home",
  "shop hospital bag essentials": "home",
  "new in nursery": "home",
  "view all picnicware": "home",
  "children's bedding sets": "home",
  "throws, blankets & bedspreads": "home",
  "cushions": "home",
  "ready made curtains & voiles": "home",
  "rugs": "home",
  "pictures": "home",
  "bean bags & pouffes": "home",
  "for children": "home",
  "greetings cards": "home",
  "notecards & invitations": "home",
  "wedding stationery": "home",
  "kids' bedroom offers": "home",
  "nursery offers": "home",
  "toys special offers": "home",
  "beds": "home",
  "view all mattresses": "home",
  "children's storage & toy boxes": "home",
  "children's bookcases": "home",
  "children's wardrobes": "home",
  "children's bedside tables": "home",
  "children's chests of drawers": "home",
  "children's desks": "home",
  "character bedding": "home",
  "kids bedroom ranges": "home",
  "wall stickers": "home",
  "baby pods & nests": "home",
  "children's lighting": "home"
}
